// extracted by mini-css-extract-plugin
export default {"page-layout":"styles_page-layout__eWSrQ"};